import classnames from 'classnames';

export interface IHorizontalFormGroupProps {
    children: React.ReactNode;
    className?: string;
    hasErrors?: boolean;
    linkedField?: string;
    noMargin?: boolean;
    preventDoesNotHaveDangerPropagation?: boolean;
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function HorizontalFormGroup(props: IHorizontalFormGroupProps) {
    const className = classnames('form-group form-row', props.className || '', {
        'has-danger': props.hasErrors,
        'does-not-have-danger': !props.hasErrors,
        'm-0': props.noMargin,
    });

    return (
        <div
            className={className}
            // eslint-disable-next-line react/no-unknown-property
            linked-field={props.linkedField}
        >
            {props.children}
        </div>
    );
}
